import {
    FAIL_REQUEST,
    MAKE_REQUEST,
    ORGANIZATIONS_LIST
} from "./actionTypes";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as constantMessages from "../../../../constants/constatntMessages";

export const makeRequest = () => {
    return {
        type: MAKE_REQUEST,
    };
};
export const failRequest = (err) => {
    return {
        type: FAIL_REQUEST,
        payload: err,
    };
};

export const setOrganizationsList = (data) => {
    return {
        type: ORGANIZATIONS_LIST,
        payload: data,
    };
};

export const OrganizationsList = (payload,accessToken) => {
    console.log('Payload inside Organizations List', payload);
    
    return (dispatch) => {
        dispatch(makeRequest());
        const webApiUrl = `${process.env.REACT_APP_API_URL}/api/V1/admin/organization/organizationList`;
        const headerObject = {
            headers: {
                "Content-Type": "application/json",
                 Authorization: accessToken,
            },
            params: {
                limit: payload.limit,
                order: payload.order,
                page: payload.page,         
            }
        };
        const bodyPayload = {
            searchKey: payload.searchKey ? payload.searchKey : undefined,
            toDate: payload.toDate ? payload.toDate : undefined,
            fromDate: payload.fromDate ? payload.fromDate : undefined,
        };
        console.log('headerObject', headerObject);
        console.log('bodyPayload', bodyPayload);
        console.log('webApiUrl', webApiUrl);
        axios.post(webApiUrl, bodyPayload, headerObject)
            .then((result) => {
                const resData = result.data;
                console.log('ResDatasss---', resData);
                if (
                    (!resData.success && resData.data?.totalCount !== 0) ||
                    resData.data?.isInValidUser
                ) {
                    toast.error(resData.message, {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                }
                dispatch(setOrganizationsList(resData));
            })
            .catch((err) => {
                dispatch(failRequest(err.message));
                toast.error(constantMessages.serverErrorMessage, {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            });
    }
}